export default __webpack_public_path__ + "static/media/placeholder_business02-nl-web.d39baa16.png";